export default __webpack_public_path__ + "static/berge-meer_1_1_en-6d3514231e89c2c2a2ef3c3501ff6188.png";